import type { WSStatus } from '@/lib/ws';
import { cn } from '@/lib/utils';

const statusConfig: Record<WSStatus, { label: string; color: string }> = {
  connected: { label: 'Conectado', color: 'bg-success' },
  connecting: { label: 'Reconectando...', color: 'bg-warning animate-pulse' },
  disconnected: { label: 'Desconectado', color: 'bg-muted-foreground' },
};

export function ConnectionIndicator({ status }: { status: WSStatus }) {
  const cfg = statusConfig[status];

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className={cn('inline-block h-2 w-2 rounded-full', cfg.color)} />
      {cfg.label}
    </div>
  );
}
